"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const serializeMemoryInfo = (memoryInfo) => {
    if (!memoryInfo)
        return {};
    return ["jsHeapSizeLimit", "totalJSHeapSize", "usedJSHeapSize"].reduce((obj, key) => {
        return { ...obj, [key]: memoryInfo[key] || null };
    }, {});
};
exports.default = serializeMemoryInfo;
